import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

// Iconos
import { MdAssessment } from 'react-icons/md';
import { FaHeartbeat, FaHandsHelping, FaRunning, FaUserAlt} from 'react-icons/fa';
import { GiShield } from 'react-icons/gi';

// Pincelada
import brushStroke from '../assets/images/brush-stroke.webp';

import './Services.css';

const buttonVariants = {
  hidden:  { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  hover:   { scale: 1.1, boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.3)' },
  tap:     { scale: 0.95 }
};

// Actualización de los servicios con nombres ajustados según el contenido del cliente
const items = [
  { icon: FaUserAlt,         label: 'ENTRENAMIENTO PERSONAL',    route: '/entrenamiento-personal' },
  { icon: FaRunning,         label: 'MBZ PROFESIONAL',           route: '/mbz-profesional' },
  { icon: FaHeartbeat,       label: 'REHABILITACIÓN DE LESIONES',                  route: '/rehab-xf' },
  { icon: FaHandsHelping,    label: 'FISIOTERAPIA',              route: '/fisioterapia' },
  { icon: MdAssessment,      label: 'ENTRENAMIENTO FUNCIONAL',      route: '/valoracion-funcional' },
  { icon: GiShield,          label: 'PREPARACIÓN OPOSICIONES',   route: '/entrenamiento-oposiciones' }
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="services-container">
      <h1 className="title">
        <div className="title-container">
          <img src={brushStroke} alt="" className="brush-behind" />
          <span className="title-text">SERVICIOS</span>
        </div>
      </h1>

      <section className="grid-section">
        <motion.div
          className="grid"
          initial="hidden"
          animate="visible"
          transition={{ staggerChildren: 0.15 }}
        >
          {items.map(({ icon: Icon, label, route }) => (
            <motion.div
              key={label}
              className="grid-item"
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
              onClick={() => navigate(route)}
            >
              <Icon className="service-icon" />
              <span className="service-title">{label}</span>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </div>
  );
}
